import React, { useEffect, useState, useRef } from "react";
import RadioButton from "../../../../RadioButton/RadioButton";
import TextField from "../../../../TextField/TextField";
import Checkbox from "../../../../Checkbox/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPersonalDashboard,
  updateSubmissionData,
} from "../../../../../redux/slices/personalDashboardSlice";
import {
  getInitializeServicesData,
  selectCompanyDashboard,
} from "../../../../../redux/slices/companyDashboardSlice";
import { CheckIcon } from "@heroicons/react/20/solid";
import chevronIcon from "../../../../../assets/images/chevronIcon.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addMonths, subMonths, startOfMonth, format, parse } from "date-fns";
import MonthPicker from "../../../../MonthPicker/MonthPicker";
import calendarIcon from "../../../../../assets/images/circum_calendar.png";
import errorIcon from '../../../../../assets/icons/error-icon.svg'
import { currencies } from "../../../../../utils/helpers";

import {
  getUserDetails,
  selectUser,
} from "../../../../../redux/slices/userSlice";
import { motion, AnimatePresence } from "framer-motion";
import OutsideClickHandler from "react-outside-click-handler";

import cn from 'classnames'

function Second() {
  const dispatch = useDispatch();
  const { updateSubmissionsData } = useSelector(selectPersonalDashboard);
  const State = useSelector(selectCompanyDashboard);
  const { CategoriesAndUsersData } = State;
  const companyUsers = CategoriesAndUsersData.company_users;
  const [searchResults, setSearchResults] = useState([]);
  const [selected, setSelected] = useState(null);
  const [costUnsure, setCostUnsure] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [activeIndex, setActiveIndex] = useState(-1);
  const ulItemRefs = useRef([]);
  const servicesUlItemRefs = useRef([]);
  const UserState = useSelector(selectUser);
  const { userDetails } = UserState;
  const company_currency = userDetails?.currency_symbol || 'USD';
  const [currencyDropdown, setCurrencyDropdown] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [toggleIcon, setToggleIcon] = useState(false);

  const handleUserInput = (field, value) => {
    if (value.trim() === "") {
      setSearchText("");
      setSearchResults([]);
    } else {
      setSearchText(value);

      const filteredUsers = companyUsers.filter((user) => {
        const searchTerm = value.toLowerCase();
        return (
          user.name.toLowerCase().includes(searchTerm) ||
          user.email.toLowerCase().includes(searchTerm) ||
          user.id.toString().includes(searchTerm)
        );
      });
      setSearchResults(filteredUsers);
    }
    // dispatch(updateSubmissionData({ field, value }));
  };
  const handleInput = (field, value) => {
    dispatch(updateSubmissionData({ field, value }));
  };

  const handleDateChange = (date) => {
    const formattedDate = date ? format(date, "yyyy-MM-dd") : null;
    setSelectedDate(date);
    dispatch(updateSubmissionData({ field: "neededByDate", value: formattedDate }));
  };

  const handleCostUnsureChange = (e) => {
    const checked = e.target.checked;
    handleInput("costUnsure", checked);

    // clear cost when user marks "I'm not sure"
    if (checked) {
      handleInput("cost", "");
    }
  };


  const updateSelectedDate = (date) => {
    const updatedDate = startOfMonth(date);
    const updatedDateStr = format(updatedDate, 'yyyy-MM-dd');
    dispatch(updateSubmissionData({ field: "neededByDate", value: updatedDateStr }));
    setSelectedDate(date);
  };

  const incrementMonth = () => {
    setSelectedDate((prevDate) => {
      const currentDate = prevDate || new Date();
      const newDate = addMonths(currentDate, 1);
      const updatedDateStr = format(startOfMonth(newDate), 'yyyy-MM-dd');
      dispatch(updateSubmissionData({ field: "neededByDate", value: updatedDateStr }));
      return newDate;
    });
  };

  const decrementMonth = () => {
    setSelectedDate((prevDate) => {
      const currentDate = prevDate || new Date();
      const newDate = subMonths(currentDate, 1);
      const updatedDateStr = format(startOfMonth(newDate), 'yyyy-MM-dd');
      dispatch(updateSubmissionData({ field: "neededByDate", value: updatedDateStr }));
      return newDate;
    });
  };

  useEffect(() => {
    const calendarVal = document.getElementById("calendarVal");
    if (calendarVal) {
      if (!selectedDate) {
        calendarVal.textContent = "Select date";
      } else {
        calendarVal.textContent = format(selectedDate, "MMMM yyyy");
      }
    }
  }, [selectedDate]);

  useEffect(() => {
    const neededByDateStr = updateSubmissionsData.neededByDate;
    if (neededByDateStr) {
      const parsedDate = parse(neededByDateStr, 'yyyy-MM-dd', new Date());
      setSelectedDate(parsedDate);
    }
  }, [updateSubmissionsData.neededByDate]);

  useEffect(() => {
    const currency = updateSubmissionsData.currency;
    if (currency) {
      setSelectedCurrency(currency);
    }
  }, [updateSubmissionsData.currency]);

  const setButtonRef = (element, index) => {
    ulItemRefs.current = ulItemRefs.current.filter(Boolean);
    ulItemRefs.current[index] = element;
  };

  const handleResultClick = (result) => {
    handleUserInput("expensed_by_name", result.name);
    dispatch(
      updateSubmissionData({ field: "expensed_by_name", value: result.name })
    );
    setSearchResults([]);
    setSelected(result);
  };

  const handleKeyDown = (e, result) => {
    if (!searchResults.length || !ulItemRefs.current.length) {
      return;
    }

    if (e.key === "ArrowDown") {
      const nextIndex = (activeIndex + 1) % ulItemRefs.current.length;
      setActiveIndex(nextIndex);
      ulItemRefs.current[nextIndex]?.focus();
      return;
    }

    if (e.key === "ArrowUp") {
      const prevIndex =
        (activeIndex - 1 + ulItemRefs.current.length) %
        ulItemRefs.current.length;
      setActiveIndex(prevIndex);
      ulItemRefs.current[prevIndex]?.focus();
      return;
    }

    if (e.key === "Enter" && result?.name) {
      handleResultClick(result);
    }
  };

  useEffect(() => {
    dispatch(getInitializeServicesData());
    dispatch(getUserDetails());
  }, []);

  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
    dispatch(updateSubmissionData({ field: "currency", value: currency }));
    setCurrencyDropdown(false);
  };

  // useEffect(() => {
  //   if (company_currency) {
  //     setSelectedCurrency(company_currency);
  //   }
  // }, [company_currency]);


  return (
    <div className="flex flex-col md:w-[536px] md:h-[404px] sm:pr-[16px] pb-[16px] gap-[24px]">
      <div className="flex flex-start">
        <span className="text-primary text-left !text-[18px] !leading-[36px]">
          Is this service currently expensed for work?
        </span>
      </div>
      <div>
        <label className="flex flex-start justify-between text-primary !font-semibold mb-[8px]">
          How much will this cost?
        </label>

        <div className={`${updateSubmissionsData.costUnsure && "disabled opacity-[0.3] pointer-events-none"} flex gap-2 items-end`}>
          <div className="w-1/2">
            <TextField
              placeholder="Enter amount"
              value={updateSubmissionsData.cost || ""}
              onChange={(e) => handleInput("cost", e.target.value)}
            />
          </div>
          <div className="w-1/2 relative">
            <OutsideClickHandler onOutsideClick={() => setCurrencyDropdown(false)}>
              <input
              readOnly
              value={selectedCurrency ? `${selectedCurrency}` : ""}
              placeholder="Currency"
              onClick={() => setCurrencyDropdown(!currencyDropdown)}
              className={cn('bg-[#363D50] placeholder:text-[#A5AEBC] focus:border-white !text-white focus:text-white border border-[#596073] rounded-[12px] focus:ring-[#596073] focus:border-[#596073] block w-full px-[16px] py-[12px] custom_text cursor-pointer', currencyDropdown ? 'ring-[#FFD74A]' : '')}
            />
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <img 
                  src={chevronIcon} 
                  alt="icon" 
                  className={`h-2 w-3 transition-transform duration-200 ${currencyDropdown ? "rotate-180" : ""}`} 
                />
              </div>
              <AnimatePresence>
                {currencyDropdown && (
                  <motion.div
                    className="absolute top-[52px] w-full rounded-[16px] overflow-auto bg-[#293043] p-2 scrollbar-hide border border-[#596073] max-h-48 z-20 shadow-lg"
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.15 }}
                  >
                    {currencies.map((currency, idx) => {
                      const isSelected = selectedCurrency?.trim().toUpperCase() === currency.trim().toUpperCase();
                      return (
                        <div
                          key={idx}
                          className={`text-left px-2 py-2.5 rounded-[12px] border border-solid cursor-pointer hover:bg-[#434A5D] active:border-[#FFD74A] mb-1 last:mb-0 ${
                            isSelected ? "border-[#FFD74A] bg-[#434A5D]" : "border-transparent"
                          }`}
                          onClick={() => handleCurrencyChange(currency)}
                        >
                          {currency}
                        </div>
                      );
                    })}
                  </motion.div>
                )}
              </AnimatePresence>
            </OutsideClickHandler>
          </div>
        </div>

        {/* Checkbox Section */}
        <div className="flex flex-col mt-[6px]">
          <div className="flex gap-[3px] items-center mt-[8px] mb-[24px]">
            <Checkbox
              onClick={handleCostUnsureChange}
              name="costUnsure"
              id="costUnsure"
              checked={updateSubmissionsData.costUnsure || false}
              className="websiteCheckbox"
            />
            <label htmlFor="costUnsure" className="ml-2 flex flex-start text-secondary">
              I’m not sure
            </label>
          </div>
        </div>

        <div className="flex flex-col MonthPickerWrap relative">
          <label className="flex flex-start justify-between text-primary !font-semibold mb-[8px]">
            When is it needed by?
      {/*      {!updateSubmissionsData.neededByDate && (
              <span>
                <img
                  src={errorIcon}
                  alt="Error Icon"
                  className="w-[24px] h-[24px]"
                />
              </span>
            )}*/}
          </label>
          <div className="relative">
            <img src={calendarIcon} alt="icon" className="absolute top-3 left-2 w-6 h-6" />
            <DatePicker
              selected={selectedDate}
              onChange={handleDateChange}
              dateFormat="MMM dd yyyy"
              placeholderText="Select date"
              className="focus:outline-none focus:ring-0 focus:shadow-none focus:!border-white bg-[#363D50] border border-[#596073] rounded-[12px] block w-full !pl-[40px] pr-[16px] py-[12px] text-white"
              popperClassName="date-custome-picker w-full"
              wrapperClassName="w-full"
              onCalendarOpen={() => setToggleIcon(true)}
              onCalendarClose={() => setToggleIcon(false)}
            />
            <div className={`absolute top-[20px] right-[20px] transition-transform duration-200 ${toggleIcon ? "rotate-180" : "" }`}>
              <img src={chevronIcon} alt="icon" className="h-2 w-3" />
            </div>
          </div>
        </div>

        <div className="flex flex-start pt-[12px] pb-[8px] pr-[24px] gap-[8px] mt-[16px]">
          <RadioButton
            checked={
              updateSubmissionsData?.expense_type === "expensed_by_other"
            }
            onChange={() => handleInput("expense_type", "expensed_by_other")}
          />
          <div className="flex flex-col text-left w-full">
            <span
              className="text-secondary !text-[18px] mb-[4px] cursor-pointer w-full block"
              onClick={() => handleInput("expense_type", "expensed_by_other")}
            >
              Yes - this service is expensed by someone else.
            </span>
            {updateSubmissionsData?.expense_type === "expensed_by_other" && (
              <TextField
                placeholder={"Enter person, group, or team name"}
                value={searchText}
                onChange={(e) =>
                  handleUserInput("expensed_by_name", e.target.value)
                }
              />
            )}
            {searchResults.length > 0 && (
              <div className="relative">
                <ul
                  tabIndex={0}
                  className="z-10 absolute mt-1 max-h-40 scrollbar-hide w-full overflow-auto bg-[#293043] p-2 rounded-[16px]"
                >
                  {searchResults.map((result, i) => (
                    <li
                      tabIndex={i}
                      ref={(el) => setButtonRef(el, i)}
                      key={result.id}
                      onKeyDown={(e) => handleKeyDown(e, result)}
                      onClick={() => handleResultClick(result)}
                      className={`relative cursor-default py-2 pl-10 pr-4 text-left transition-colors duration-300 hover:bg-[#363D50] rounded-[12px] border border-solid border-transparent active:border-[#FFD74A] mb-2 last:mb-0 ${
                        selected === result
                          ? "bg-[#363D50] !border-[#FFD74A]"
                          : ""
                      }`}
                    >
                      <div className="flex flex-col">
                        <span className="text-primary">{result.name}</span>
                        <span className="text-secondary">
                          {result.distinction}
                        </span>
                      </div>

                      {selected === result && (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                          <CheckIcon className="h-5 w-5" aria-hidden="true" />
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-start pt-[12px] pb-[8px] pr-[24px] gap-[8px]">
          <RadioButton
            checked={updateSubmissionsData?.expense_type === "not_expensed"}
            onChange={() => handleInput("expense_type", "not_expensed")}
          />
          <div className="text-left w-full">
            <span
              className="text-secondary !text-[18px] cursor-pointer w-full block"
              onClick={() => handleInput("expense_type", "not_expensed")}
            >
              No - This service isn’t expensed
            </span>
          </div>
        </div>

        <div className="flex flex-start pt-[12px] pb-[8px] pr-[24px] gap-[8px]">
          <RadioButton
            checked={updateSubmissionsData?.expense_type === "no_idea"}
            onChange={() => handleInput("expense_type", "no_idea")}
          />
          <div className="text-left w-full">
            <span
              className="text-secondary !text-[18px] cursor-pointer w-full block"
              onClick={() => handleInput("expense_type", "no_idea")}
            >
              I don’t know
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Second;